import { Outlet } from 'react-router-dom';

const EquipmentCostsReportsPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
}

export default EquipmentCostsReportsPage;